import { Zone } from "../ComponentBase";
import { updateCornerBoxes } from "./createCornerBoxes";

export const onDrag = (
  e: MouseEvent,
  zone: Zone,
  component: HTMLElement,
  invisibleLayer: HTMLElement
) => {
  const elementBounds = component.getBoundingClientRect();
  const mouseCoordsInElement = {
    x: e.pageX - elementBounds.left,
    y: e.pageY - elementBounds.top,
  };

  // console.log(e.pageX, e.clientX, elementBounds.right, elementBounds.width);
  // console.log(e.pageX - elementBounds.right + elementBounds.width)

  // drag in a straight horizontal line
  if (e.shiftKey && (e.ctrlKey || e.metaKey)) {
    onDragCtrlShift(
      mouseCoordsInElement,
      elementBounds,
      zone,
      component,
      invisibleLayer
    );

    return;
  }

  // drag in a straight vertical line
  if (e.shiftKey) {
    onDragShift(
      mouseCoordsInElement,
      elementBounds,
      zone,
      component,
      invisibleLayer
    );

    return;
  }

  // drag diagonally
  onDragCorner(
    mouseCoordsInElement,
    elementBounds,
    zone,
    component,
    invisibleLayer
  );

  updateCornerBoxes(component);

  return;
};

const onDragCorner = (
  mouseCoordsInElement: {
    x: number;
    y: number;
  },
  elementBounds: ClientRect,
  zone: Zone,
  component: HTMLElement,
  invisibleLayer: HTMLElement
) => {
  switch (zone) {
    case "nw":
      dragNorthWest(
        mouseCoordsInElement,
        elementBounds,
        component,
        invisibleLayer
      );
      break;

    case "ne":
      dragNorthEast(
        mouseCoordsInElement,
        elementBounds,
        component,
        invisibleLayer
      );
      break;

    case "sw":
      dragSouthWest(
        mouseCoordsInElement,
        elementBounds,
        component,
        invisibleLayer
      );
      break;

    case "se":
      dragSouthEast(
        mouseCoordsInElement,
        elementBounds,
        component,
        invisibleLayer
      );
      break;

    case "n":
      dragNorth(mouseCoordsInElement, elementBounds, component, invisibleLayer);
      break;

    case "e":
      dragEast(mouseCoordsInElement, elementBounds, component, invisibleLayer);
      break;

    case "w":
      dragWest(mouseCoordsInElement, elementBounds, component, invisibleLayer);
      break;

    case "s":
      dragSouth(mouseCoordsInElement, elementBounds, component, invisibleLayer);
      break;

    default:
      break;
  }
};

const onDragShift = (
  mouseCoordsInElement: {
    x: number;
    y: number;
  },
  elementBounds: ClientRect,
  zone: Zone,
  component: HTMLElement,
  invisibleLayer: HTMLElement
) => {
  switch (zone) {
    case "nw":
    case "ne":
      dragNorth(mouseCoordsInElement, elementBounds, component, invisibleLayer);
      break;

    case "sw":
    case "se":
      dragSouth(mouseCoordsInElement, elementBounds, component, invisibleLayer);
      break;

    default:
      break;
  }
};

const onDragCtrlShift = (
  mouseCoordsInElement: {
    x: number;
    y: number;
  },
  elementBounds: ClientRect,
  zone: Zone,
  component: HTMLElement,
  invisibleLayer: HTMLElement
) => {
  switch (zone) {
    case "nw":
    case "sw":
      dragWest(mouseCoordsInElement, elementBounds, component, invisibleLayer);
      break;

    case "ne":
    case "se":
      dragEast(mouseCoordsInElement, elementBounds, component, invisibleLayer);
      break;

    default:
      break;
  }
};

const dragNorth = (
  mouseCoordsInElement: {
    x: number;
    y: number;
  },
  elementBounds: ClientRect,
  component: HTMLElement,
  invisibleLayer: HTMLElement
) => {
  if (component && invisibleLayer) {
    if (mouseCoordsInElement.y < 0) {
      component.style.height = elementBounds.height + 1 + "px";
      component.style.top = elementBounds.top - 1 + "px";
      invisibleLayer.style.height = elementBounds.height + 21 + "px";
      invisibleLayer.style.top = elementBounds.top - 11 + "px";
    }

    if (mouseCoordsInElement.y > 0 && elementBounds.height > 0) {
      component.style.top = elementBounds.top + 1 + "px";
      component.style.height = elementBounds.height - 1 + "px";
      invisibleLayer.style.top = elementBounds.top + 11 + "px";
      invisibleLayer.style.height = elementBounds.height + 19 + "px";
    }
  }
};

const dragWest = (
  mouseCoordsInElement: {
    x: number;
    y: number;
  },
  elementBounds: ClientRect,
  component: HTMLElement,
  invisibleLayer: HTMLElement
) => {
  if (component && invisibleLayer) {
    if (mouseCoordsInElement.x < 0) {
      component.style.width = elementBounds.width + 1 + "px";
      component.style.left = elementBounds.left - 1 + "px";
      invisibleLayer.style.width = elementBounds.width + 21 + "px";
      invisibleLayer.style.left = elementBounds.left - 11 + "px";
    }

    if (mouseCoordsInElement.x > 0 && elementBounds.width > 0) {
      component.style.width = elementBounds.width - 1 + "px";
      component.style.left = elementBounds.left + 1 + "px";
      invisibleLayer.style.width = elementBounds.width + 19 + "px";
      invisibleLayer.style.left = elementBounds.left + 11 + "px";
    }
  }
};

const dragEast = (
  mouseCoordsInElement: {
    x: number;
    y: number;
  },
  elementBounds: ClientRect,
  component: HTMLElement,
  invisibleLayer: HTMLElement
) => {
  if (component && invisibleLayer) {
    if (mouseCoordsInElement.x < elementBounds.width) {
      component.style.width = elementBounds.width - 1 + "px";
      invisibleLayer.style.width = elementBounds.width + 19 + "px";
    }

    if (mouseCoordsInElement.x > elementBounds.width - 1) {
      component.style.width = elementBounds.width + 1 + "px";
      invisibleLayer.style.width = elementBounds.width + 21 + "px";
    }
  }
};

const dragSouth = (
  mouseCoordsInElement: {
    x: number;
    y: number;
  },
  elementBounds: ClientRect,
  component: HTMLElement,
  invisibleLayer: HTMLElement
) => {
  if (component && invisibleLayer) {
    if (mouseCoordsInElement.y > elementBounds.height - 1) {
      component.style.height = elementBounds.height + 1 + "px";
      invisibleLayer.style.height = elementBounds.height + 21 + "px";
    }

    if (mouseCoordsInElement.y < elementBounds.height) {
      component.style.height = elementBounds.height - 1 + "px";
      invisibleLayer.style.height = elementBounds.height + 19 + "px";
    }
  }
};

const dragNorthWest = (
  mouseCoordsInElement: {
    x: number;
    y: number;
  },
  elementBounds: ClientRect,
  component: HTMLElement,
  invisibleLayer: HTMLElement
) => {
  dragNorth(mouseCoordsInElement, elementBounds, component, invisibleLayer);
  dragWest(mouseCoordsInElement, elementBounds, component, invisibleLayer);
};

const dragNorthEast = (
  mouseCoordsInElement: {
    x: number;
    y: number;
  },
  elementBounds: ClientRect,
  component: HTMLElement,
  invisibleLayer: HTMLElement
) => {
  dragNorth(mouseCoordsInElement, elementBounds, component, invisibleLayer);
  dragEast(mouseCoordsInElement, elementBounds, component, invisibleLayer);
};

const dragSouthWest = (
  mouseCoordsInElement: {
    x: number;
    y: number;
  },
  elementBounds: ClientRect,
  component: HTMLElement,
  invisibleLayer: HTMLElement
) => {
  dragSouth(mouseCoordsInElement, elementBounds, component, invisibleLayer);
  dragWest(mouseCoordsInElement, elementBounds, component, invisibleLayer);
};

const dragSouthEast = (
  mouseCoordsInElement: {
    x: number;
    y: number;
  },
  elementBounds: ClientRect,
  component: HTMLElement,
  invisibleLayer: HTMLElement
) => {
  dragSouth(mouseCoordsInElement, elementBounds, component, invisibleLayer);
  dragEast(mouseCoordsInElement, elementBounds, component, invisibleLayer);
};
